import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonContainer, Container, Text } from './EmailDisclaimerModal.styled';
import Modal from 'components/Modal/Modal';
import { Button } from 'components/v2/Buttons/Button/Button';
import { pageUrl } from 'utilities/pageUrl';

import { EmailDisclaimerModalProps } from './EmailDisclaimerModal.types';

export const EmailDisclaimerModal = ({ open, onClose }: EmailDisclaimerModalProps) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <Modal label="Account changes" open={open}>
      <Container>
        <Text>
          You will be prompted to reset your password as part of this process. Do you want to
          continue?
        </Text>
        <ButtonContainer>
          <Button label={'Cancel'} category="primary-dark" size="lg" onClick={() => onClose()} />
          <Button
            label={'Continue'}
            category="primary"
            size="lg"
            onClick={() => navigate(pageUrl.changeEmail())}
          />
        </ButtonContainer>
      </Container>
    </Modal>
  );
};
